import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { PanelButton } from './Flex.jsx'
import _merge from 'lodash/merge'
import _get from 'lodash/get'
import { FaCheck, FaTimes } from 'react-icons/fa'

const useAlert = (args, dt) => {
  let options = _merge(
    {
      active: false,
      modal: true,
      variant: 'MODAL',
      header: '',
      body: '',
      footer: '',
      props: {
        div: {
          className: 'm-0 p-0',
        },
        dialog: {},
        header: {},
        body: {},
        footer: {},
        OK: { variant: 'primary', label: 'OK' },
        YES: { variant: 'success', label: 'YES' },
        NO: { variant: 'danger', label: 'NO' },
        DISMISS: { variant: 'secondary', label: 'DISMISS' },
        CANCEL: { variant: 'secondary', label: 'CANCEL' },
      },
    },
    args
  )

  //Important! onClick must be last property so that passed in prop does not override
  if (args && args.type === 'CONFIRM') {
    options.footer = [
      <div className='d-flex m-0 p-0' key='c1'>
        <Button key='1' disabled={true}>
          CONFIRM
        </Button>
        <PanelButton
          key='2'
          title='Confirm Deletion'
          color='green'
          onClick={() => {
            if (options.props.YES && options.props.YES.onClick) options.props.YES.onClick({ show, hide, state, data })
            else hide()
          }}
        >
          <FaCheck key='i1' color='green' size='1.25em' />
        </PanelButton>
        <PanelButton
          key='3'
          title='Cancel Deletion'
          color='red'
          onClick={() => {
            if (options.props.NO && options.props.NO.onClick) options.props.NO.onClick({ show, hide, state, data })
            else hide()
          }}
        >
          <FaTimes key='i2' color='red' size='1.25em' />
        </PanelButton>
      </div>,
    ]
  }
  if (args && args.type === 'OK') {
    options.footer = [
      <Button
        key='1'
        {...options.props.OK}
        onClick={() => {
          if (options.props.OK && options.props.OK.onClick) options.props.OK.onClick({ show, hide, state, data })
          else hide()
        }}
      >
        {options.props.OK.label}
      </Button>,
    ]
  }
  if (args && args.type === 'YESNO') {
    options.footer = [
      <Button
        {...options.props.YES}
        onClick={() => {
          if (options.props.YES && options.props.YES.onClick) options.props.YES.onClick({ show, hide, state, data })
          else hide()
        }}
        key='1'
      >
        {options.props.YES.label}
      </Button>,
      <Button
        {...options.props.NO}
        onClick={() => {
          if (options.props.NO && options.props.NO.onClick) options.props.NO.onClick({ show, hide, state, data })
          else hide()
        }}
        key='2'
      >
        {options.props.NO.label}
      </Button>,
    ]
  }
  if (args && args.type === 'INFO') {
    options.footer = [
      <Button
        key='1'
        {...options.props.OK}
        onClick={() => {
          if (options.props.OK && options.props.OK.onClick) options.props.OK.onClick({ show, hide, state, data })
          else hide()
        }}
      >
        {options.props.OK.label}
      </Button>,
      <Button
        {...options.props.CANCEL}
        onClick={() => {
          if (options.props.CANCEL && options.props.CANCEL.onClick) options.props.CANCEL.onClick({ show, hide, state, data })
          else hide()
        }}
        key='2'
      >
        {options.props.CANCEL.label}
      </Button>,
    ]
  }

  const [data, setDataState] = useState(dt)
  const [state, setState] = useState(options)
  const show = (timeout, dt) => {
    setState({ ...state, active: true, data: dt })
    if (dt) setData({ ...data, ...dt })
    if (timeout) setTimeout(() => setState({ ...state, active: false }), timeout)
  }
  const hide = () => {
    setState({ ...state, active: false })
  }
  const setAlert = (obj, timeout = null) => {
    setState({ ...state, ...obj })
    if (timeout) setTimeout(() => setState(options), timeout)
  }
  const setData = (obj) => {
    setDataState({ ...data, ...obj })
  }
  return { ...state, data: data, show, hide, setAlert, setData }
}

const Div = (props) => {
  const { hook, children, ...o } = props
  let cls = `${_get(o, 'className')} ${_get(hook.props.div, 'className')} ${hook.active ? '' : ' d-none'}`
  return (
    <div {...o} {...hook.props.div} className={cls}>
      {children}
      {hook.footer || <></>}
    </div>
  )
}

const Alert = (props) => {
  const { hook, dismiss, children, ...o } = props
  //Set Class to d-none on Dialog (not modal) - augment with passed props, hook props
  let cls = `${_get(o, 'className')} ${_get(hook.props.dialog, 'className')} ${hook.active ? '' : ' d-none'}`
  if (!hook.modal) cls += `${hook.active ? '' : ' d-none'}`
  if (hook.variant === 'DIV') {
    //FOR VARIANT OF DIV - SIMPLY RETURN CHILDREN OF DIV AND FOOTER (CONTAINING CONTROLS)
    return (
      <Div hook={hook}>
        {dismiss ? (
          <button type='button' className='close flex-dismiss' onClick={() => hook.hide()}>
            <FaTimes className='flex-dismiss-icon' />
          </button>
        ) : (
          <></>
        )}
      </Div>
    )
  } else {
    //FOR ALL OTHER VARIANTS IT IS A STATIC OR POPUP MODAL
    let Control = hook.variant === 'MODAL' ? Modal : Modal.Dialog
    return (
      <Control show={hook.variant === 'MODAL' ? hook.active : ''} {...o} {...hook.props.dialog} className={cls}>
        {hook.header ? <Alert.Header hook={hook} {...hook.props.header} /> : <></>}
        {hook.body ? <Alert.Body hook={hook} {...hook.props.body} /> : <></>}
        {children}
        {hook.footer ? <Alert.Footer hook={hook} {...hook.props.footer} /> : <></>}
        {dismiss ? (
          <button className='flex-dismiss' type='button' onClick={() => hook.hide()}>
            <FaTimes color='grey' />
          </button>
        ) : (
          <></>
        )}
      </Control>
    )
  }
}
Alert.Header = (props) => {
  const { hook, children, ...o } = props
  return (
    <Modal.Header {...o}>
      {hook && hook.header ? hook.header : null}
      {children}
    </Modal.Header>
  )
}
Alert.Body = (props) => {
  const { hook, children, ...o } = props
  return (
    <Modal.Body {...o}>
      {hook && hook.body ? hook.body : null}
      {children}
    </Modal.Body>
  )
}
Alert.Footer = (props) => {
  const { hook, children, ...o } = props
  return (
    <Modal.Footer {...o}>
      {hook && hook.footer ? hook.footer : null}
      {children}
    </Modal.Footer>
  )
}

export default Alert
export { useAlert }
